<template>
  <div class="pt-8 pl-8" style="width: 100%">
    <div class="pb-4 text-h2" style="width: 50%">Web of Buildings</div>
    <div class="pb-2 text-h5 font-weight-light" style="width: 30%">
      Welcome to Web of Buildings: Enhancing Property Management with Advanced
      Technologies.
    </div>
    <div class="pb-2 text-h5 font-weight-light" style="width: 30%">
      Experience the benefits of RealEstateCore, Digital Twins, and Open Web
      Technologies for efficient and innovative Real Estate solutions.
    </div>
    <!-- display: block -->
    <v-btn large class="mb-2" color="primary" to="/search">
      <v-icon color="secondary" left>mdi-home-city</v-icon>Get started
    </v-btn>
    <div class="text-h6 font-weight-light" style="width: 30%">
      This is an experimental release of the WoB Explorer, designed to process
      RealEstateCore-based digital twins from the Azure Digital Twins (ADT)
      service.
    </div>
  </div>
  <!--
  <v-card width="50%">
    <v-card-text class="text-h2"
      >Welcome to the Web of Buildings Explorer</v-card-text
    >
    <v-card-text class="text-body-1"
      >This is an experimental version of the WoB Explorer. At a later stage
      background for WoB goes here.</v-card-text
    >
    <v-divider></v-divider>
    <v-card-actions class="justify-end">
      <v-btn color="secondary" to="/search"
        >Get started <v-icon>mdi-office-building-outline</v-icon></v-btn
      >
    </v-card-actions>
  </v-card>
  -->
</template>

<script>
export default {
  component: 'WelcomeMessage',
}
</script>
